import { Popover } from 'antd';
import React, { Fragment } from 'react';
import FlagIconFactory from 'react-flag-icon-css';
import styled from 'styled-components';
import { Cell } from '../../styles/styled-common';
import { currencySymbolByCode, noEmpty } from '../../utils';
import geodata from '../../utils/geodata';

const Flag = FlagIconFactory(React, { useCssModules: false })

const FlagItem = styled.span`
  ${'' /* margin-top: 4px; */}
  font-size: 1.7em;
  padding: 0 4px;

  .flag-icon {
    border-radius: 5px;
    box-shadow: 1px 1px 4px 1px #000;
    border: 1px solid rgba(255,255,255,0.1);
    background-size: cover;
  }
`

const StyledCell = styled(Cell)`
  text-align: center;
  font-size: 14px;
  color: ${p => p.theme.textOffwhite};
  width: 100%;
  img {
    display: block;
    margin: 0 auto;
    max-width: 60%;
  }
`

const FlagsContainer = styled.div`
  width: 100%;
  margin: 0 -4px;
`

export default class LocationsCell extends React.PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    const { currency, locations, justifyContent, ...props } = this.props

    if (!locations) return <div>Missing Locations Data</div>

    const flags = locations.sort(({country: a},{country: b}) => {
      return geodata.countries[a].name.localeCompare(geodata.countries[b].name)
    }).map(({ country: countryCode, pops, extra }) => {
      const country = geodata.countries[countryCode]
      const { name: countryName } = country

      const symbol = currencySymbolByCode(currency)

      let popsItems =
        pops &&
        pops.map(({ city, state, extra: cityExtra }) => {
          const popTitle = noEmpty`${city}${state ? noEmpty`${city && ', '}${state}` : ''}${cityExtra ? ` (+${symbol}${cityExtra})` : ''}`,
          return <div key={city || state}>{popTitle}</div>
        })

      const title = countryName + (extra > 0 ? ` (+${symbol}${extra})` : '')

      return (
        <Popover
          key={countryCode}
          overlayClassName={popsItems ? '' : 'hide-inner-content'}
          content={<Fragment>{popsItems}</Fragment>}
          arrowPointAtCenter={true}
          title={title}
        >
          <FlagItem className="bah-flag">
            <Flag code={countryCode} />
          </FlagItem>
        </Popover>
      )
    })

    return (
      <StyledCell {...props}>
        <FlagsContainer
          flexWrap="wrap"
          justifyContent={justifyContent || "space-between"}
          alignItems="center"
        >
          {flags}
        </FlagsContainer>
      </StyledCell>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/LocationsCell.jsx